import React from 'react';

export default function ReLinkConfirmModal({
    deploymentName,
    newlyLinked,
    alreadyLinked,
    onConfirm,
    onCancel,
}) {
    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 10000,
            background: 'rgba(0,0,0,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
        }} onClick={onCancel}>
            <div style={{
                background: '#fff', borderRadius: 8, padding: 24, maxWidth: 440,
                boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            }} onClick={e => e.stopPropagation()}>
                <h3 style={{ margin: '0 0 12px', fontSize: 16 }}>
                    Link recipients to <em>{deploymentName}</em>?
                </h3>
                <div style={{ margin: '0 0 16px', fontSize: 14, color: '#5F6368', lineHeight: 1.5 }}>
                    <ul style={{ margin: '0 0 8px 18px', padding: 0 }}>
                        <li>{newlyLinked} will be newly linked</li>
                        <li>
                            {alreadyLinked} are already linked &mdash; re-linking updates their link timestamp
                        but does not re-send.
                        </li>
                    </ul>
                    <div>Use Send separately to dispatch.</div>
                </div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                    <button onClick={onConfirm} style={{
                        padding: '6px 16px', border: 'none', borderRadius: 4,
                        background: '#1967D2', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600,
                    }}>Confirm</button>
                    <button onClick={onCancel} style={{
                        padding: '6px 16px', border: '1px solid #DADCE0', borderRadius: 4,
                        background: '#fff', color: '#3C4043', cursor: 'pointer', fontSize: 13,
                    }}>Cancel</button>
                </div>
            </div>
        </div>
    );
}
